import React from 'react';

import { useRecoilValue } from 'recoil';

import { blockDateRange, blockDisplayHeader, customizedBlock } from 'venn-state';

import { Block } from '../../components/core';

import { DefaultDateRange } from '../../components/secondary/date-ranges';
import { BenchmarkType } from '../../components/secondary/benchmark-type';

import { DefaultSubjects } from '../../components/secondary/subjects/default-subjects';
import { RollingPeriod } from '../../components/secondary/rolling-period';

interface RollingCorrelationHeaderProps {
  id: string;
}

export const RollingCorrelationHeader = ({ id }: RollingCorrelationHeaderProps) => {
  const title = useRecoilValue(blockDisplayHeader(id));
  const { selectedMetrics, relativeToBenchmark, subHeader } = useRecoilValue(customizedBlock(id));
  const dateRange = useRecoilValue(blockDateRange(id));

  return (
    <>
      <Block.HeaderTopContainer id={id}>
        <Block.Title>
          <Block.Headline id={id}>{title}</Block.Headline>
          {subHeader && <Block.SubHeadline id={id}>{subHeader}</Block.SubHeadline>}
        </Block.Title>

        <Block.Metadata id={id}>
          <DefaultDateRange dateRange={dateRange} />
          <BenchmarkType id={id} />
          {relativeToBenchmark && <Block.MetadataItem iconType="calculator">Relative to Benchmark</Block.MetadataItem>}
          <RollingPeriod id={id} />
        </Block.Metadata>
      </Block.HeaderTopContainer>

      <DefaultSubjects id={id} metric={selectedMetrics[0]! || ''} relativeToBenchmark={relativeToBenchmark} />
    </>
  );
};
